export default (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minHeight: '100%',
    },
  },
  stepper: {
    width: '100%',
    background: 'none',
  },
  card: {
    width: 600,
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
  },

  submitBtn: {
    width: 200,
  },

  loading: {
    position: 'absolute',
    left: 0,
    backgroundColor: '#fff',
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  hide: {
    display: 'none',
  }
});
